// extracted by mini-css-extract-plugin
module.exports = {"label":"formInput_label__3R5La","labelVerb":"formInput_labelVerb__3P9PI","input":"formInput_input__17obx","inputVerb":"formInput_inputVerb__GfRe7"};